import { render, staticRenderFns } from "./IncorporatedDocuments.vue?vue&type=template&id=18e44a4e&scoped=true&"
import script from "./IncorporatedDocuments.vue?vue&type=script&lang=ts&"
export * from "./IncorporatedDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./IncorporatedDocuments.vue?vue&type=style&index=0&id=18e44a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e44a4e",
  null
  
)

export default component.exports